import { createTheme } from "@mui/material/styles"

export const theme = createTheme({
  typography: {
    fontFamily: "'HM Slussen', system-ui, Avenir, Helvetica, Arial, sans-serif",
  },
  colorSchemes: {
    light: true,
  },
})
